import * as R from 'ramda';
import { IGeoValue } from '../../types/filters/user_geo';
import { IJsonQuery } from './types';
import { setGeo } from './helpers';

export function selectGeo(jsonQuery: IJsonQuery): (geoValue: IGeoValue) => IJsonQuery {
  return geoValue => {
    if (jsonQuery.geo && jsonQuery.geo.value && !!R.find(R.equals(geoValue), jsonQuery.geo.value)) {
      return jsonQuery;
    }

    const nextGeo = (jsonQuery.geo && R.clone(jsonQuery.geo.value)) || [];

    return setGeo()(jsonQuery)([...nextGeo, geoValue]);
  };
}
